import { makeRecord } from "sdi/source";
import { fromRecord } from "sdi/locale";

export function attribution() {
  return `parking.brussels`;
}

export function credits() {
  return fromRecord(
    makeRecord(
      "Fond de plan: \nBrussels UrbIS ®© \nParadigm \nSPF Finances",
      "Achtergrond: \nBrussels UrbIS ®© \nParadigm \nFOD Financiën"
    )
  );
}
